import React, { PureComponent, Fragment } from 'react';
import { Row, Button } from 'reactstrap';
import { connect } from 'react-redux';
import printJS from 'print-js';
import LoadingOverlay from 'Components/LoadingOverlay';
import BreadcrumbContainer from 'Components/BreadcrumbContainer';
import { Colxx, Separator } from 'Components/CustomBootstrap';
import { transactionsPrint, errorReset } from 'Redux/actions';
import * as transactionsReducer from 'Redux/transactions/reducer';
import IntlMessages from 'Util/IntlMessages';
import './PageTransactionPrint.scss';

class PageTransactionPrint extends PureComponent {
	constructor(props) {
		super(props);
		this.breadcrumb = [
			{ id: 'menu.transaction', href: '/transaction/list' },
			{ id: 'transaction-print.heading', href: '/transaction/print/' + this.getId(props) },
		];
		this.getId = this.getId.bind(this);
		this.fetchData = this.fetchData.bind(this);
		this.onClickPrintHandler = this.onClickPrintHandler.bind(this);
	}

	componentDidMount() {
		this.fetchData();
		this.props.errorReset('transaction');
	}

	componentDidUpdate(prevProps) {
		const id = this.getId();
		const print = this.props.print.get(id);
		const prevPrint = prevProps.print.get(id);
		if (print && print !== prevPrint) {
			this.onClickPrintHandler();
		}
	}

	getId(props = null) {
		if (!props) {
			props = this.props;
		}
		return props.match.params.transactionId;
	}

	fetchData() {
		const id = this.getId();
		this.props.transactionsPrint(id);
	}

	onClickPrintHandler() {
		const id = this.getId();
		const print = this.props.print.get(id);
		printJS({
			printable: print.pdf,
			type: 'pdf',
			base64: true
		});
	}

	render() {
		const id = this.getId();
		const print = this.props.print.get(id);
		const status = this.props.status.get('print');
		const isLoading = status === 'fetching';
		return (
			<Fragment>
				<Row>
					<Colxx xxs="12">
						<BreadcrumbContainer
							heading={ id ? <span>{ id }</span> : <IntlMessages id="transaction.heading" /> }
							items={ this.breadcrumb }
							match={ this.props.match }
						/>
						<div className="float-right">
							<Button size="lg" color="primary" onClick={ this.onClickPrintHandler } disabled={ isLoading }>
								PRINT
							</Button>
						</div>
						<div className="clearfix" />
					</Colxx>
				</Row>

				<Separator className="mb-5" />

				<LoadingOverlay active={ isLoading }>
					<div className="transaction-print-iframe-container">
						<iframe
							src={ print && print.pdf ? `data:application/pdf;base64,${print.pdf}` : 'about:blank' }
							className="transaction-print-iframe"
						/>
					</div>
				</LoadingOverlay>
			</Fragment>
		);
	}
}

export default connect(
	transactionsReducer.selector,
	{
		transactionsPrint,
		errorReset,
	}
)(PageTransactionPrint);